import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import { Alert, AlertTitle, Box, Typography } from "@mui/material";

/**
 * Placeholder for dashboard sections that need future backend endpoints.
 * @param {string} title
 * @param {string[]} futureEndpoints - e.g. ['GetStageAging']
 * @param {string} [description]
 */
const DashboardTodoPanel = ({
  title,
  futureEndpoints = [],
  description = "این بخش پس از پیاده‌سازی API مربوطه فعال می‌شود.",
}) => (
  <Alert
    severity="info"
    icon={<ConstructionOutlinedIcon />}
    sx={{ mb: 2, borderRadius: 2 }}
  >
    <AlertTitle>{title}</AlertTitle>
    <Typography variant="body2" sx={{ mb: futureEndpoints.length ? 1 : 0 }}>
      {description}
    </Typography>
    {futureEndpoints.length ? (
      <Box component="ul" sx={{ m: 0, pr: 2.5 }}>
        {futureEndpoints.map((endpoint) => (
          <li key={endpoint}>
            <Typography variant="caption" component="span" sx={{ fontFamily: "monospace" }}>
              {endpoint}
            </Typography>
          </li>
        ))}
      </Box>
    ) : null}
  </Alert>
);

export default DashboardTodoPanel;
